import { Box, Link, ListItem, UnorderedList } from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";

const EdssQuickLInks = ({ info }) => {
  const navigate = useNavigate();
  const links = [
    {
      id: 1,
      title: "Case Links",
      path: "caselinks",
    },
  ];
  const handleNavigation = (link) => {
    navigate(`/CaseView/${link}/${info?.id}/${info.person}`);
  };
  return (
    <Box p={2}>
      <UnorderedList>
        {links?.map((link, idx) => {
          return (
            <Link
              onClick={() => handleNavigation(link?.path)}
              key={idx}
              textDecor="none"
            >
              <ListItem fontSize="md" color="#2b6cb0" borderLeft="none">
                {link?.title}
              </ListItem>
            </Link>
          );
        })}
      </UnorderedList>
    </Box>
  );
};

export default EdssQuickLInks;
